import React from 'react';
import Moment from 'moment';
import {
  StyleSheet, Text, ViewStyle, View, TextStyle,
} from 'react-native';
import { useSelector } from 'react-redux';
import { DateRange, isLiveMode } from '../../redux/dateRangeSlice';
import Colors from '../../constants/Colors';
import { isSameDate, isSameYear } from '../../constants/Utils';
import Style from '../../constants/Style';
import CompareArrowsIcon from '../CompareArrowsIcon';

interface DateLabelProps {
  style?: ViewStyle | ViewStyle[],
  textStyle?: TextStyle | TextStyle[],
  range?: DateRange,
  compareRange?: DateRange,
  comparisonHidden?: boolean,
}

const formattedDate = (range: DateRange): string => {
  const startDate: Date = new Date(range.start);
  const endDate: Date = new Date(range.end);
  const sameYear: boolean = isSameYear(startDate, endDate);
  const sameDate: boolean = isSameDate(startDate, endDate);
  let output: string = '';

  if (sameDate && isSameDate(new Date(), startDate)) {
    output += 'Today ';
  }
  if (!sameDate) {
    output += `${Moment(startDate).format(`D MMM${sameYear ? '' : '[,] yyyy'}`)} - `;
  }
  output += Moment(isLiveMode(range) ? new Date() : endDate)
    .format(`D MMM${sameYear ? '' : '[,] yyyy'}`);
  if (sameYear) {
    output += `, ${startDate.getFullYear()}`;
  }
  return output;
};

const DateLabel = ({
  style, textStyle, range, compareRange, comparisonHidden,
}: DateLabelProps) => {
  const currentRange: DateRange = range
    ?? useSelector((state: { dateRange: DateRange }) => state.dateRange);
  const currentComparisonRange: DateRange = comparisonHidden ? null : compareRange
    ?? useSelector((state: { dateComparisonRange: DateRange }) => state.dateComparisonRange);
  return <View style={[styles.container, style]}>
    <Text style={[styles.date, textStyle]}>
      {formattedDate(currentRange)}
    </Text>
    {!!(currentComparisonRange && currentComparisonRange.start && currentComparisonRange.end)
      && <View style={Style.row}>
        <CompareArrowsIcon />
        <Text style={[styles.date, styles.dateCompared, textStyle]}>
          {formattedDate(currentComparisonRange)}
        </Text>
      </View>}
  </View>;
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  date: {
    fontSize: 12,
    lineHeight: 20,
    color: Colors.light.hereworksBlack400,
    fontFamily: 'Roboto_500Medium',
    marginEnd: 12,
  },
  dateCompared: {
    color: Colors.light.hereworksYellow600,
    marginStart: 12,
  },
});

export default DateLabel;
